import React, { useEffect, useState } from 'react';
import * as util from "../../utils/util";
import api from "../../utils/api";
import { Box, Grid, Typography } from "@mui/material";
import Top from "../Top";
import Bottom from "../Bottom";
import GaugeChart from "../../components/GaugeChart";
import ScatterChart from "../../components/ScatterChart";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { useLocation } from "react-router-dom";

const initMonthInfo = {
  RECORD_COUNT: 0,  // 기록 일수
  COMPLETE_PERCENT: 0,  // 목표 달성률
  COMPLETE_COUNT: 0,  // 목표 달성 일수
  // TARGET_AVG: 0,  // 평균 목표 값
  VALUE_AVG: 0,  // 평균 값
}

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const MonthHistory = () => {
  const [monthInfo, setMonthInfo] = React.useState(initMonthInfo);
  const [monthValue, setMonthValue] = useState(new Date().getMonth() + 1);
  const [monthSeries, setMonthSeries] = React.useState([
    {label: '수축기', data: [{x: 0, y: 0, id: ''}]}, {label: '이완기', data: [{x: 0, y: 0, id: ''}]}
  ]);
  const [title, setTitle] = React.useState('');
  const [unit, setUnit] = React.useState('');
  const { state } = useLocation();
  const { type } = state ?? {};

  useEffect(() => {
    setMonthData();
  }, [monthValue]);

  function setMonthData() {
    if (util.strNull(window.localStorage.userCusID) !== '') {
      const date = new Date();
      const month = date.getFullYear() + '-' + (('00' + monthValue.toString()).slice(-2));
      api.get(`app/api/v1/AP_002_013?type=${type}&month=${month}`).then(res => {
        setMonthInfo(res.data.result_data.info);
      }).catch(function (error) {
        console.log(error)
      });

      params.token = localStorage.getItem('token') || '';
      params.from = date.getFullYear() + (('00' + monthValue.toString()).slice(-2)) + '01';
      params.to = date.getFullYear() + (('00' + monthValue.toString()).slice(-2)) + '31';
      params.target = util.getDateByCustom('yyyyMMdd', 0);

      let apiUrl = 'app/api/v1/AP_002_014'; setTitle('혈압'); setUnit('mmHg');

      api.get(`${apiUrl}?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
        if (res.data.result_code === '0') {
          let tempArr = [];
            for (let item of res.data.result_data.data.pressure_v2) {
              let obj = { bloodPressureLow: 0, bloodPressureHigh: 0, month: '' };
              obj.month = item.date.split('.')[1];
              obj.bloodPressureLow = item.bloodPressureLow;
              obj.bloodPressureHigh = item.bloodPressureHigh;
              tempArr.push(obj);
            }
            
            const monthSeriesTemp = [
              {
                label: '수축기',
                data: tempArr.map((v :any) => ({ x: Number(v.month), y: v.bloodPressureHigh, id: v.month }))
              },
              {
                label: '이완기',
                data: tempArr.map((v :any) => ({ x: Number(v.month), y: v.bloodPressureLow, id: v.month }))
              },
            ]
            
            setMonthSeries(monthSeriesTemp); // 월간현황 차트 series 세팅
        }
      }).catch(function (error) {
        console.log(error)
      });
    }
  }
  
  // 이완기(61~80), 수축기(101~120) 값에 따른 상태값
  function getStatusForTargetPressure(targetPressure: any) {
    const low = Number(targetPressure.bloodPressureLow);
    const high = Number(targetPressure.bloodPressureHigh);
    if ((low >= 61 && low <= 80) && (high >= 101 && high <= 120)) {
      return '혈압 조절을 잘 하고 있어요';
    } else if (low === 0 && high === 0) {
      return '아직 기록이 없어요';
    }  else if (low > 80 || high > 120) {
      return '일일 평균 혈압이 높아요';
    } else if (low < 61 || high < 101) {
      return '일일 평균 혈압이 낮아요';
    }
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title={'월간 '+title+' 기록'} />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', }}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setMonthValue((prev) => prev - 1)} sx={{ 'display': monthValue > 1 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
            {new Date().getFullYear() + '년 ' + monthValue + '월'}
            <ArrowRightIcon onClick={() => setMonthValue((prev) => prev + 1)} sx={{ 'display': monthValue < new Date().getMonth() + 1 && monthValue > 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Box sx={{
              '& .semicircle-gauge svg': { width: '240px', height: '130px' },
              '& .CircleChart .circleText': { fontSize: 24, },
            }}>
              <GaugeChart targetValue={util.getPercentValueForGauge({bloodPressureHigh: monthInfo.VALUE_AVG.toString().split('/')[0], bloodPressureLow: monthInfo.VALUE_AVG.toString().split('/')[1]})} />
            </Box>

            <Box sx={{ mb: 2 }}>
              {
                monthInfo.RECORD_COUNT > 0 ? (
                  monthInfo.COMPLETE_PERCENT === 100 ? (
                    <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                      <Typography sx={{ fontSize: 14, color: '#ef8322', fontWeight: 700 }}>혈압 조절을 잘 하고 있어요</Typography>
                    </Stack>
                  ) : (
                    <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                      <Typography sx={{ fontSize: 14, color: '#555', fontWeight: 700 }}>{getStatusForTargetPressure({bloodPressureHigh: monthInfo.VALUE_AVG.toString().split('/')[0], bloodPressureLow: monthInfo.VALUE_AVG.toString().split('/')[1]})}</Typography>
                    </Stack>
                  ) 
                ) : (
                  <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                    <Typography sx={{ fontSize: 14, color: '#777', fontWeight: 700 }}>아직 기록이 없어요</Typography>
                  </Stack>
                )
              }
            </Box>

            <Stack direction={'row'} justifyContent={'space-evenly'} alignItems={'center'} sx={{ width: '100%', mb: 1 }}>
              <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} >
                <Typography sx={{ fontSize: 14, color: '#555', }}>일일 평균 수치</Typography>
                <Typography component="div" sx={{ fontSize: 20, color: '#777', fontWeight: 700 }}>
                  {monthInfo.VALUE_AVG}
                  <Typography component="span" sx={{ fontSize: 14, color: '#777', ml: 1, }}>{unit}</Typography>
                </Typography>
              </Stack>
              <Divider orientation="vertical" variant="middle" flexItem />
              <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                <Typography sx={{ fontSize: 14, color: '#555', }}>정상 수치일</Typography>
                <Typography component="div" sx={{ fontSize: 20, color: '#777', fontWeight: 700 }}>
                  {util.formatComma(monthInfo.COMPLETE_COUNT)}
                  <Typography component="span" sx={{ fontSize: 14, color: '#777', ml: 1, }}>일</Typography>
                </Typography>
              </Stack>
            </Stack>

          </Stack>


          <Box sx={{ bgcolor: '#fff', p: '10px 10px 20px 10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>월간현황</Typography>
              </Stack>
            </Stack>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <Typography component="div" sx={{ fontSize: 12, color: '#555', mr: .5, }}>이번 달의
                <Typography component="span" sx={{ fontSize: 14, color: '#0069ce', fontWeight: 700, mb: 2, }}> {title} </Typography>
                기록이에요.
              </Typography>
{/*
              <Stack direction={'row'} justifyContent={'space-evenly'} sx={{ bgcolor: '#f5f5f5', borderRadius: 3, mt: 1, width: '100%' }}>
                <Stack alignItems={'center'} justifyContent={'center'} sx={{ py: 1, px: 0, textAlign: 'center', }}>
                  <Typography sx={{ fontSize: 12, color: '#777', fontWeight: 700 }}>수축기</Typography>
                </Stack>
                <Divider orientation="vertical" variant="middle" flexItem />
                <Box sx={{ py: 1, px: 0, textAlign: 'center', }}>
                  <Typography sx={{ fontSize: 12, color: '#777', }}>정상
                    <Typography component={'span'} sx={{ fontSize: 12, color: '#333', ml:.5 }}>20회</Typography>
                  </Typography>
                </Box>

                <Box sx={{ py: 1, px: 0, textAlign: 'center', }}>
                  <Typography sx={{ fontSize: 12, color: '#777', }}>높음 
                    <Typography component={'span'} sx={{ fontSize: 12, color: '#333', ml:.5 }}>8회</Typography>
                  </Typography>
                </Box>

                <Box sx={{ py: 1, px: 0, textAlign: 'center' }}>
                  <Typography sx={{ fontSize: 12, color: '#777', }}>낮음
                    <Typography component={'span'} sx={{ fontSize: 12, color: '#333', ml:.5 }}>0회</Typography>
                  </Typography>
                </Box>
              </Stack>

              <Stack direction={'row'} justifyContent={'space-evenly'} sx={{ bgcolor: '#f5f5f5', borderRadius: 3, mt: 1, width: '100%' }}>
                <Stack alignItems={'center'} justifyContent={'center'} sx={{ py: 1, px: 0, textAlign: 'center', }}>
                  <Typography sx={{ fontSize: 12, color: '#777', fontWeight: 700 }}>이완기</Typography>
                </Stack>
                <Divider orientation="vertical" variant="middle" flexItem />
                <Box sx={{ py: 1, px: 0, textAlign: 'center', }}>
                  <Typography sx={{ fontSize: 12, color: '#777', }}>정상
                    <Typography component={'span'} sx={{ fontSize: 12, color: '#333', ml:.5 }}>20회</Typography>
                  </Typography>
                </Box>

                <Box sx={{ py: 1, px: 0, textAlign: 'center', }}>
                  <Typography sx={{ fontSize: 12, color: '#777', }}>높음 
                    <Typography component={'span'} sx={{ fontSize: 12, color: '#333', ml:.5 }}>8회</Typography>
                  </Typography>
                </Box>

                <Box sx={{ py: 1, px: 0, textAlign: 'center' }}>
                  <Typography sx={{ fontSize: 12, color: '#777', }}>낮음
                    <Typography component={'span'} sx={{ fontSize: 12, color: '#333', ml:.5 }}>0회</Typography>
                  </Typography>
                </Box>
              </Stack>
              */}
            </Box>
            <Divider />

            <Box sx={{ mt: -3.5, '& .MuiChartsAxis-tickContainer:last-child' : {display:'none'}  }}>

              <ScatterChart series={monthSeries} colors={['#9b00fb', '#3dbb27', ]} />
              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mt={'-10px'} mb={1}>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={1}>
                  <Box sx={{ width: 10, height: 10, bgcolor: '#800d8d', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>수축기</Typography>
                </Stack>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={1} >
                  <Box sx={{ width: 10, height: 10, bgcolor: '#3dbb27', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>이완기</Typography>
                </Stack>
              </Stack>
              
            </Box>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

export default MonthHistory;